<template>
    <authenticated-layout>

        <div class="d-flex justify-space-between align-center mb-4">
            <h2
                class="font-semibold text-base text-gray-800 leading-tight mx-4"
            >
                #{{ referralPartner.id }} {{ referralPartner.name }} ( {{ referralPartner.email }} )
            </h2>

            <v-btn
                variant="flat"
                class="ml-2"
                size="small"
                color="primary"
                :href="route('admin-referrals.index')"
            >
                Back
            </v-btn>
        </div>


        <v-card class="px-4">
            <v-card-title
                class="d-flex justify-space-between align-center p-4"
            >
                <h2
                    class="font-semibold text-base text-gray-800 leading-tight"
                >
                    Data
                </h2>
            </v-card-title>
            <div class="grid grid-cols-12 sm:grid-cols-12 gap-2 p-4">

                <div class="d-flex align-center col-span-6">
                    <v-text-field
                        v-model="updatePartnerForm.name"
                        label="Name"
                        variant="outlined"
                        density="compact"
                        hide-details
                    />
                </div>

                <div class="d-flex align-center col-span-6">
                    <v-text-field
                        v-model="updatePartnerForm.email"
                        label="Email"
                        variant="outlined"
                        density="compact"
                        hide-details
                    />
                </div>

                <div class="d-flex align-center col-span-4">
                    <v-text-field
                        v-model="updatePartnerForm.partner_key"
                        label="Partner Key"
                        variant="outlined"
                        density="compact"
                        hide-details
                    />
                </div>

                <div class="d-flex align-center col-span-4">
                    <v-text-field
                        v-model="updatePartnerForm.referral_key"
                        label="Referral Key"
                        variant="outlined"
                        density="compact"
                        hide-details
                    />
                </div>

                <div class="d-flex align-center col-span-4">
                    <v-text-field
                        v-model="updatePartnerForm.earned"
                        label="Earned"
                        variant="outlined"
                        density="compact"
                        hide-details
                        readonly="readonly"
                    />
                </div>

                <div class="d-flex align-center col-span-12 mb-2">
                    <v-btn
                        color="primary"
                        @click="updatePartner()"
                    >Save data</v-btn>
                </div>
            </div>
        </v-card>

        <v-card class="px-4 mt-4">
            <v-card-title
                class="d-flex justify-space-between align-center p-4"
            >
                <h2
                    class="font-semibold text-base text-gray-800 leading-tight"
                >
                    Payouts
                </h2>
            </v-card-title>
            <form @submit.prevent="submit">
                <div class="grid grid-cols-12 sm:grid-cols-12 gap-2 p-4">
                    <div class="d-flex align-center col-span-2">
                        <v-text-field
                            v-model="addPayoutForm.amount"
                            label="Amount"
                            variant="outlined"
                            density="compact"
                            type="number"
                            hide-details
                            readonly="readonly"
                        />
                    </div>
                    <div class="d-flex align-center col-span-9">
                        <v-text-field
                            v-model="addPayoutForm.customers"
                            label="Customers"
                            variant="outlined"
                            density="compact"
                            hide-details
                            readonly="readonly"
                        />
                    </div>

                    <div class="d-flex align-center col-span-1">
                        <v-btn
                            type="submit"
                            color="primary"
                            @click="addPayout()"
                        >Pay</v-btn>
                    </div>
                </div>
            </form>

            <div class="overflow-x-auto p-4">
                <table class="zebra-table mb-4">
                    <tr>
                        <th class="text-left">
                            Customers
                        </th>
                        <th class="text-left">
                            Amount
                        </th>
                        <th class="text-left">
                            Date
                        </th>
                        <th class="text-left">
                            Actions
                        </th>
                    </tr>

                    <tr
                        v-for="referralPayout in referralPayouts"
                        :key="`payout-${referralPayout.id}`"
                    >
                        <td>{{ referralPayout.customers }}</td>
                        <td>{{ referralPayout.amount }}</td>
                        <td>{{ referralPayout.payout_at }}</td>
                        <td>
                            <v-btn
                                size="x-small"
                                variant="flat"
                                color="red"
                                @click="deletePayout(referralPayout.id)"
                            >
                                Delete
                            </v-btn>
                        </td>
                    </tr>
                </table>
            </div>
        </v-card>


        <v-card class="px-4 my-4">
            <v-card-title
                class="d-flex justify-space-between align-center p-4"
            >
                <h2
                    class="font-semibold text-base text-gray-800 leading-tight"
                >
                    Potentials customers
                </h2>
            </v-card-title>
            <div class="overflow-x-auto p-4">
                <table class="zebra-table mb-4">
                    <tr>
                        <th class="text-left">
                            Name
                        </th>
                        <th class="text-left">
                            Email
                        </th>
                        <th class="text-left">
                            Phone
                        </th>
                        <th class="text-left">
                            Address
                        </th>
<!--                        <th class="text-left">-->
<!--                            Data-->
<!--                        </th>-->
                        <th class="text-left">
                            Offer sent
                        </th>
                        <th class="text-left">
                            Offer accepted
                        </th>
                        <th class="text-left">
                            Date submitted
                        </th>
                        <th class="text-left">
                            Actions
                        </th>
                    </tr>

                    <tr
                        v-for="referralPotentialCustomer in referralPotentialCustomers"
                        :key="`user-${referralPotentialCustomer.id}`"
                    >
                        <td>{{ referralPotentialCustomer.name }}</td>
                        <td>{{ referralPotentialCustomer.email }}</td>
                        <td>{{ referralPotentialCustomer.phone }}</td>
                        <td>{{ referralPotentialCustomer.address }}</td>
<!--                        <td>{{  referralPotentialCustomer.lead_data }}</td>-->
                        <td>{{ referralPotentialCustomer.offer_sent ? 'Yes' : 'No' }}</td>
                        <td>{{ referralPotentialCustomer.offer_accepted ? 'Yes' : 'No' }}</td>
                        <td>{{ referralPotentialCustomer.created_at }}</td>
                        <td>
                            <div v-if="!referralPotentialCustomer.is_payed">
                                <v-btn
                                    v-if="customers.includes(referralPotentialCustomer.id)"
                                    size="x-small"
                                    variant="flat"
                                    color="red"
                                    @click="deleteCustomerPayout(referralPotentialCustomer)"
                                >
                                    Remove from Payout
                                </v-btn>
                                <v-btn
                                    v-else
                                    size="x-small"
                                    variant="flat"
                                    color="green"
                                    @click="addCustomerPayout(referralPotentialCustomer)"
                                >
                                    Payout
                                </v-btn>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </v-card>


        <v-card class="px-4 my-4">
            <v-card-title
                class="d-flex justify-space-between align-center p-4"
            >
                <h2
                    class="font-semibold text-base text-gray-800 leading-tight"
                >
                    Emails
                </h2>
            </v-card-title>
            <div class="overflow-x-auto p-4">
                <table class="zebra-table mb-4">
                    <tr>
                        <th class="text-left">
                            Name
                        </th>
                        <th class="text-left">
                            Email
                        </th>
                        <th class="text-left">
                            Phone
                        </th>
                    </tr>

                    <tr
                        v-for="referralEmail in referralEmails"
                        :key="`user-${referralEmail.id}`"
                    >
                        <td>{{ referralEmail.name }}</td>
                        <td>{{ referralEmail.email }}</td>
                        <td>{{ referralEmail.phone }}</td>

                    </tr>
                </table>
            </div>
        </v-card>
    </authenticated-layout>
</template>

<script>
import AuthenticatedLayout from "@/Layouts/Authenticated.vue";
import { useForm } from '@inertiajs/inertia-vue3'
import { onUpdated } from 'vue'

export default {
    components: {
        AuthenticatedLayout,
    },
    props: {
        referralPartner: {
            type: Object,
            required: true,
        },
        referralPotentialCustomers: {
            type: Object,
            required: true,
        },
        referralEmails: {
            type: Object,
            required: true,
        },
        referralPayouts: {
            type: Object,
            required: true,
        },
        payoutPerLeadPrice: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            customers: [],
        };
    },
    computed: {
        customerNames() {
            let value = ''
            const customers = this.customers
            this.referralPotentialCustomers.forEach(function (customer) {
                if (customers.includes(customer.id)) {
                    if (value === '') {
                        value += customer.name
                    } else {
                        value += ', ' + customer.name
                    }
                }
            })

            return value;
        },
    },
    setup(props) {
        const updatePartnerForm = useForm({
            name: props.referralPartner.name,
            email: props.referralPartner.email,
            partner_key: props.referralPartner.partner_key,
            referral_key: props.referralPartner.referral_key,
            earned: props.referralPartner.earned,
            referral_partner_id: null,
        })

        const addPayoutForm = useForm({
            amount: 0,
            customers: '',
            referral_partner_id: null,
        })

        onUpdated(() => {
            updatePartnerForm.earned = props.referralPartner.earned
        })

        return { updatePartnerForm, addPayoutForm }
    },
    methods: {
        updatePartner() {
            this.updatePartnerForm.referral_partner_id = this.referralPartner.id
            this.updatePartnerForm.post(this.route('admin-referrals.update-partner') , {
                preserveScroll: true,
                onSuccess: function () {

                },
            })
        },
        addCustomerPayout(referralPotentialCustomer) {
            if (!this.customers.includes(referralPotentialCustomer.id)) {
                this.customers.push(referralPotentialCustomer.id)
                if (!this.addPayoutForm.amount) {
                    this.addPayoutForm.amount = 0;
                }
                this.addPayoutForm.amount += parseInt(this.payoutPerLeadPrice)
            }

            this.addPayoutForm.customers = this.customerNames
        },
        deleteCustomerPayout(referralPotentialCustomer) {
            if (this.customers.includes(referralPotentialCustomer.id)) {
                const index = this.customers.indexOf(referralPotentialCustomer.id)
                this.customers.splice(index, 1)
                this.addPayoutForm.amount -= parseInt(this.payoutPerLeadPrice)
            }

            this.addPayoutForm.customers = this.customerNames
        },
        addPayout() {
            const $this = this
            this.addPayoutForm.referral_partner_id = this.referralPartner.id
            this.addPayoutForm.customers = this.customers;
            this.addPayoutForm.post(this.route('admin-referrals.add-payout') , {
                preserveScroll: true,
                onSuccess: function () {
                    $this.addPayoutForm.reset()
                    $this.customers = []
                },
            })
        },
        deletePayout(referralPayoutId) {
            this.$inertia.delete(this.route('admin-referrals.delete-payout', {
                referralPayout: referralPayoutId
            }));
        },
    },
};
</script>

<style scoped>
table {
    width: 100%;
    table-layout: fixed;
    font-size: 12px;
}

.zebra-table tr:nth-child(even) {
    background-color: #f2f2f2;
}

@media screen and (max-width: 1024px) {
    table {
        width: auto;
    }
}

th {
    padding: 10px 0px;
    text-align: left;
    box-sizing: border-box;
    padding-left: 10px;
    border-bottom: 1px solid #aaa;
}

td {
    text-align: left;
    box-sizing: border-box;
    padding: 5px 0px;
    padding-left: 10px;
    border-bottom: 1px solid #ccc;
}
</style>
